import { action, computed, config, debug, NetbankingAPI, observable, toJS } from "aaa";
import * as _ from "lodash";
import { NetbankingAPIClient } from "network/APIClient";
import { urljoin } from "network/NetworkStapler";
import auth from "stores/AuthStore";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { OffersStore } from "stores/OffersStore";
import { OptioPayVouchersStore } from "stores/OptioPayVouchersStore";
import { IOffer } from "types/offer";
import { IPlugin, IPluginDetails, PluginCode, pluginDetailsGetText, pluginIsActive } from "types/plugins";
import { IProductDetails, productDetailsGetText } from "types/products";
import { IStoreConfiguration, IStoreHierarchy } from "types/store";

// For testing all images use route /store/image-test

export interface IStoreProduct {
    imageBig?: string;
    imageSmall?: string;
    channelProduct: string;
    productId?: string;
    title?: string;
    text?: string;
    url?: string;
    offer?: IOffer;
    textColor?: string;
    active?: boolean;
    hidden?: boolean;
    appendOfferInformation?: boolean;
    type: "PRODUCT";
    openInExternalBrowser?: boolean;
}

export interface IStorePlugin {
    productCode: PluginCode;
    name: string;
    text: string;
    imageBig?: string;
    imageSmall?: string;
    url: string;
    active?: boolean;
    hidden?: boolean;
    type: "PLUGIN";
}

export function getExternalRedirect(url: string) {
    return urljoin(config.network.appBaseUrl, url);
}

export const PRODUCTS: IStoreProduct[] = [{
    type: "PRODUCT",
    channelProduct: "CONSUMER-LOAN",
    url: getExternalRedirect("/consumer-loan?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.privateLoan.text",
}, {
    type: "PRODUCT",
    channelProduct: "KOKO",
    // textId: "store.product.koko.text",
}, {
    type: "PRODUCT",
    channelProduct: "SCLALL",
    // textId: "store.product.sclall.text",
}, {
    type: "PRODUCT",
    channelProduct: "WPDEPOT",
    // textId: "store.product.securitiesDepository.text",
}, {
    type: "PRODUCT",
    channelProduct: "CAPITALPLAN",
    // textId: "store.product.capitalPlan.text",
}, {
    type: "PRODUCT",
    channelProduct: "GOLDSAVINGSPLAN",
}, {
    type: "PRODUCT",
    channelProduct: "HOME_LOAN_CALCULATOR",
}, {
    type: "PRODUCT",
    channelProduct: "KOMFORTS",
}, {
    type: "PRODUCT",
    channelProduct: "KAPITALS",
}, {
    type: "PRODUCT",
    channelProduct: "PRAEMIENS",
}, {
    type: "PRODUCT",
    channelProduct: "SMARTS",
}, {
    type: "PRODUCT",
    channelProduct: "C-SKMCFIRSP",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.creditCardFirst.text",
}, {
    type: "PRODUCT",
    channelProduct: "C-SKMCGOLDP",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.creditCardGold.text",
}, {
    type: "PRODUCT",
    channelProduct: "C-SKMCPLAT",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.creditCardPlatinum.text",
}, {
    type: "PRODUCT",
    channelProduct: "K-MASTER-VOR",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
}, {
    type: "PRODUCT",
    channelProduct: "C-SKMCVORSCH",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
}, {
    type: "PRODUCT",
    channelProduct: "VISAMETALL",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
}, {
    type: "PRODUCT",
    channelProduct: "VISAPREM",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
}, {
    type: "PRODUCT",
    channelProduct: "C-SKMCFIRSP",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
},
{
    type: "PRODUCT",
    channelProduct: "VISASMAR",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
},
{
    type: "PRODUCT",
    channelProduct: "MASTERSMAR",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
}, {
    type: "PRODUCT",
    channelProduct: "MASTERPREM",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
}, {
    type: "PRODUCT",
    channelProduct: "MASTERPREM_N2CC",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
},
{
    type: "PRODUCT",
    channelProduct: "MASTERSMAR_N2CC",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
},
{
    type: "PRODUCT",
    channelProduct: "VISAPREM_N2CC",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
},
{
    type: "PRODUCT",
    channelProduct: "VISASMAR_N2CC",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
}, {
    type: "PRODUCT",
    channelProduct: "C-SKVIFIRS",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.creditCardFirst.text",
}, {
    type: "PRODUCT",
    channelProduct: "C-SKVIGOLD",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.creditCardGold.text",
}, {
    type: "PRODUCT",
    channelProduct: "C-SKVIPLAT",
    url: getExternalRedirect("/shop-credit-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.creditCardPlatinum.text",
},
/**
 * DBAT-4763 - Business Cards in Retail
 * Product Purchase Process for Business Cards in George Retail
 * START
 */
{
    type: "PRODUCT",
    channelProduct: "VISASMARB", // Business Smartcard C-SKVISMARB
    url: getExternalRedirect("/shop-credit-card-business?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
},
{
    type: "PRODUCT",
    channelProduct: "VISAPREMB", // Business Premiumcard C-SKVIPREMB
    url: getExternalRedirect("/shop-credit-card-business?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
},
{
    type: "PRODUCT",
    channelProduct: "VISAPREMBP", // Business Premiumcard Plus C-SKVIPREMBP
    url: getExternalRedirect("/shop-credit-card-business?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
},
{
    type: "PRODUCT",
    channelProduct: "MASTERPREB_MM",
    url: getExternalRedirect("/shop-credit-card-business?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
},
{
    type: "PRODUCT",
    channelProduct: "MASTERSMAB_MM",
    url: getExternalRedirect("/shop-credit-card-business?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.salaryAdvance.text",
},
{
    type: "PRODUCT",
    channelProduct: "C-BKMOBIL",
    url: getExternalRedirect("/shop-bank-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.bankCardMobile.text",
}, {
    type: "PRODUCT",
    channelProduct: "C-BKDSTICKER",
    url: getExternalRedirect("/shop-bank-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.bankCardSticker.text",
}, {
    type: "PRODUCT",
    channelProduct: "C-BKDMICRO",
    url: getExternalRedirect("/shop-bank-card?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.bankCardMicro.text",
}, {
    type: "PRODUCT",
    channelProduct: "MOBTOPUP",
    openInExternalBrowser: true
    // textId: "store.product.topUpPrepaid.text",
}, {
    type: "PRODUCT",
    channelProduct: "OETICKET_MA",
    // textId: "store.product.oeTicket.text",
    openInExternalBrowser: true
}, {
    type: "PRODUCT",
    channelProduct: "OETICKET",
    openInExternalBrowser: true
    // textId: "store.product.oeTicket.text",
}, {
    type: "PRODUCT",
    channelProduct: "INVESTMGR",
    // textId: "store.product.digivv.text",
}, {
    type: "PRODUCT",
    channelProduct: "ACCIDENT_INSURANCE",
    url: getExternalRedirect("/accident-insurance?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.accidentInsurance.text",
}, {
    type: "PRODUCT",
    channelProduct: "LIFE_INSURANCE",
    url: getExternalRedirect("/life-insurance?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.lifeInsurance.text",
}, {
    type: "PRODUCT",
    channelProduct: "PENSION_INSURANCE",
    url: getExternalRedirect("/pension-insurance?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.pensionInsurance.text",
}, {
    type: "PRODUCT",
    channelProduct: "CAR_LEASING",
    url: getExternalRedirect("/car-leasing?ADDITIONAL_PARAMS&access_token="),
    appendOfferInformation: true,
    // textId: "store.product.carLeasing.text",
}, {
    type: "PRODUCT",
    channelProduct: "SCLREQ",
}, {
    type: "PRODUCT",
    channelProduct: "SBAU",
    // textId: "store.product.sbau.text",
}, {
    type: "PRODUCT",
    channelProduct: "APPLELEASING",
    // titleId: "store.product.appleLeasing.title",
    // textId: "store.product.appleLeasing.text",
}, {
    type: "PRODUCT",
    channelProduct: "GIROSKONF",
    // textId: "store.product.giroKomfort.text",
}, {
    type: "PRODUCT",
    channelProduct: "GIROSPLUS",
    // textId: "store.product.giroSPlus.text",
}, {
    type: "PRODUCT",
    channelProduct: "GIROSTUD",
    // textId: "store.product.giroStudent.text",
}, {
    type: "PRODUCT",
    channelProduct: "GIROSKOMP",
    // textId: "store.product.giroKompakt.text",
}, {
    type: "PRODUCT",
    channelProduct: "EBIKE_LEASING",
}, {
    type: "PRODUCT",
    channelProduct: "IBW",
}];


type IPluginImageMap = {
    [pluginCode in PluginCode]: string
};

export const PLUGIN_IMAGES: IPluginImageMap = {
    "PI-VOUCHER": "optioPay"
};

export const PLUGINS: IStorePlugin[] = [{
    type: "PLUGIN",
    productCode: "PI-VOUCHER",
    name: "",
    text: "",
    url: "",
}];

function pluginGetUrl(plugin: IPlugin) {
    if (plugin.productCode === "PI-VOUCHER") {
        if (pluginIsActive(plugin)) {
            // Redirect to HYB-86/HYB-87
            return getExternalRedirect("/optiopay?ADDITIONAL_PARAMS&access_token=");
        } else {
            // Redirect to HYB-85
            return getExternalRedirect("/optiopay-activation?ADDITIONAL_PARAMS&access_token=");
        }
    }

    return "";
}

export class StoreStore {
    @observable storeProducts: IStoreProduct[] = [];
    @observable storePlugins: IStorePlugin[] = [];

    offersStore = new OffersStore();
    vouchersStore = new OptioPayVouchersStore();

    @observable items: (IStoreProduct | IStorePlugin)[] = [];
    @observable activePlugins: IStorePlugin[] = [];

    @observable productDetails?: IProductDetails[];

    @observable _isLoading = false;
    @observable isLoadingProducts = false;
    @observable isLoadingPlugins = false;
    @observable isLoadingConfiguration = false;

    @observable storeConfiguration?: IStoreConfiguration;
    @observable plugins: IPlugin[] = [];
    @observable pluginDetails: IPluginDetails[] = [];
    @observable categories: IStoreHierarchy | null = null;

    @computed get isLoading() {
        return this._isLoading || this.isLoadingProducts || this.isLoadingPlugins || this.vouchersStore.isLoading || this.isLoadingConfiguration;
    }

    @action async load() {
        this._isLoading = true;

        // We clone again from static config when we enter the store, because this.items will be changed
        // by filtering from offers and store.json. So next time we enter, we want a fresh start.
        // Clone products into items for initial loading state
        this.items = _.cloneDeep([...PRODUCTS, ...PLUGINS]);

        try {
            const url = config.network.cardBaseUrl + "/cards-cms/rest/store/json";
            const res = await fetch(url);
            const storeJson = await res.json();

            debug.log("### store.json parsed", storeJson);

            this.storeConfiguration = storeJson;

            await this.offersStore.load();

            debug.log("### offers loaded", toJS(this.offersStore.offers));

            const target = NetbankingAPI.getStoreHierarchy();
            this.categories = await NetbankingAPIClient.requestType(target);

            await Promise.all([
                this.loadProducts(),
                this.loadPlugins()
            ]);
        } catch (error) {
            debug.log("### error getting store.json");
            // default case -> use hardcoded order
        }

        this.applyStoreConfiguration();

        // If vouchers plugin is active load vouchers
        if (this.activePlugins.find(activePlugin => activePlugin.productCode === "PI-VOUCHER") !== undefined) {
            this.vouchersStore.load();
        }

        this._isLoading = false;
    }

    @action async loadProducts() {
        this.isLoadingProducts = true;

        // Reset the products
        this.storeProducts = _.cloneDeep(PRODUCTS);

        // Keep sorting from offers
        this.storeProducts = _.flatMap(this.offersStore.offers, offer => {
            const productItem = PRODUCTS.find(product => product.productId === offer.productId && product.channelProduct === offer.channelProduct) ||
                PRODUCTS.find(product => product.channelProduct === offer.channelProduct);

            return productItem ?
                [{
                    ...productItem,
                    offer
                }] : [];
        });

        try {
            const productDetails = await NetbankingAPIClient.requestType(NetbankingAPI.getProductDetails());

            this.productDetails = productDetails;
            debug.log("### product details loaded", toJS(this.productDetails));

            this.isLoadingProducts = false;
        } catch (error) {
            this.isLoadingProducts = false;
            throw error;
        }
    }

    @action async loadPlugins() {
        try {
            this.isLoadingPlugins = true;

            // Reset the plugins
            this.storePlugins = _.cloneDeep(PLUGINS);

            const results = await Promise.all([
                NetbankingAPIClient.requestType(NetbankingAPI.getPlugins()),
                NetbankingAPIClient.requestType(NetbankingAPI.getPluginDetails())
            ]);

            this.plugins = results[0].plugins;
            debug.log("### loaded plugins", toJS(this.plugins));

            this.pluginDetails = results[1];
            debug.log("### loaded plugin details", toJS(this.pluginDetails));
        } catch (error) {
            debug.log("### error loading plugins", error);
        } finally {
            this.isLoadingPlugins = false;
        }
    }

    @action applyStoreConfiguration() {
        this.isLoadingConfiguration = true;

        // Map missing data on our internal configuration for products
        this.storeProducts = this.storeProducts.map(storeProduct => {
            // ... search for product by channelProduct and optional productID in store json array
            const configProduct = this.storeConfiguration?.storeProducts.find(productItem => (
                productItem.channelProduct === storeProduct.channelProduct
                && productItem.productId === storeProduct.productId
            ));

            const offer = storeProduct.offer;
            let url = storeProduct.url;

            // Assign urls for products without one
            if (offer && !url) {
                if (offer.external) {
                    url = offer.external.url;
                    debug.log("### external url", url);
                } else if (offer.handover) {
                    url = offer.handover.url + "ADDITIONAL_PARAMS#access_token=";
                    debug.log("### handover url", url);
                }
            }

            if (configProduct) {
                // Found it -> add images from product details
                const productDetails = this.productDetails?.find(offerDetailItem => offerDetailItem.externalId === configProduct.channelProduct);

                if (productDetails) {
                    return {
                        ...storeProduct,
                        title: productDetailsGetText(productDetails, "NAME", auth.locale),
                        text: productDetailsGetText(productDetails, "DESC_SHORT", auth.locale),
                        active: configProduct.sale === "ACTIVE",
                        hidden: productDetails?.hidden,
                        imageBig: productDetails?.images.find(image => image.name.endsWith("Store_large.png") || image.name.endsWith("Store_large.jpg"))?.uri,
                        imageSmall: productDetails?.images.find(image => image.name.endsWith("Store_small.png") || image.name.endsWith("Store_small.jpg"))?.uri,
                        url
                    };
                }
            }
            return storeProduct;
        });

        // Map missing data on our internal configuration for plugins
        this.storePlugins = this.storePlugins.map(storePlugin => {
            // ... search for plugin by channelProduct and optional productID in store json array
            const configPlugin = this.storeConfiguration?.storeProducts.find(configPluginItem => configPluginItem.channelProduct === storePlugin.productCode);
            const plugin = this.plugins.find(pluginItem => pluginItem.productCode === storePlugin.productCode);

            if (plugin && configPlugin) {
                // Found it -> add details from product details
                const pluginDetails = this.pluginDetails?.find(pluginDetailsItem => pluginDetailsItem.externalId === plugin?.productCode);

                if (pluginDetails) {
                    const enhancedStorePlugin = {
                        ...storePlugin,
                        name: pluginDetailsGetText(pluginDetails, "NAME", auth.locale),
                        text: pluginDetailsGetText(pluginDetails, "DESC_SHORT", auth.locale),
                        imageBig: pluginDetails?.images.find(image => image.name.endsWith("Store_large.png") || image.name.endsWith("Store_large.jpg"))?.uri,
                        imageSmall: pluginDetails?.images.find(image => image.name.endsWith("Store_small.png") || image.name.endsWith("Store_small.jpg"))?.uri,
                        url: pluginGetUrl(plugin),
                        active: configPlugin.sale === "ACTIVE",
                        // sorting: configPlugin.sorting
                    };

                    if (pluginIsActive(plugin)) {
                        // Active plugins are shown in an extra section and always shown
                        this.activePlugins.push(enhancedStorePlugin);
                    }

                    return enhancedStorePlugin;
                }

                debug.log("### Found plugin but without details", plugin);
            }

            return storePlugin;
        });

        // Filter products and plugins
        this.items = [...this.storeProducts, ...this.storePlugins].filter(item => {
            if (item.type === "PRODUCT") {
                return item.active && (item as IStoreProduct).offer;
            } else if (item.type === "PLUGIN") {
                // Inactive plugins can be activated as long it is not hidden and it is active in store.json, dismiss when already activated
                return item.active && !item.hidden && !this.activePlugins.find(plugin => plugin.productCode === item.productCode);
            }

            return false;
        });

        this.isLoadingConfiguration = false;
    }
}

interface IParams extends IOffer {
    productCode?: string;
}

export function replaceAdditionalParams(url: string, params?: Partial<IParams>, appendOfferInformation?: boolean) {
    let resultUrl = url;

    // If handover url needs access token, append it
    if (_.endsWith(url, "access_token=")) {
        resultUrl += auth.accessToken;
    }

    const addParams = _.includes(resultUrl, "ADDITIONAL_PARAMS");
    if (addParams) {
        let additionalParams = "";

        if (params) {
            // Append conditionsGroupId, productId and channelProduct
            // in case handover url or external is set but we go to our own url (eg. HYB-99), appendOfferInformation forces to set these informations
            if ((!params.handover && !params.external) || appendOfferInformation) {
                if (params.conditionsGroupId) {
                    additionalParams += "&conditionsGroupId=" + params.conditionsGroupId;
                }
                if (params.productId) {
                    additionalParams += "&productId=" + params.productId;
                }
                if (params.channelProduct) {
                    additionalParams += "&channelProduct=" + params.channelProduct;
                }
            }
            if (params.productCode) {
                additionalParams += "&productCode=" + params.productCode;
            }
        }

        if (auth.locale) {
            additionalParams += "&locale=" + auth.locale;
        }
        if (externalInterfaceStore.successURL) {
            additionalParams += "&successURL=" + externalInterfaceStore.successURL;
        }
        if (externalInterfaceStore.errorURL) {
            additionalParams += "&errorURL=" + externalInterfaceStore.errorURL;
        }
        if (externalInterfaceStore.clientId) {
            additionalParams += "&clientId=" + externalInterfaceStore.clientId;
        }
        if (externalInterfaceStore.channel) {
            if (!url.includes("?channel=") && !url.includes("&channel=")) {
                // only append channel if not alread in url eg when handover url provides channel
                additionalParams += "&channel=" + externalInterfaceStore.channel;
            }
        }

        if (additionalParams) {
            const characterBeforeAdditionalParams = resultUrl.split("ADDITIONAL_PARAMS")[0].slice(-1);
            if (characterBeforeAdditionalParams === "?") {
                // If additionalParams are first query params -> remove &
                additionalParams = additionalParams.slice(1);
            } else {
                const hasOtherParams = _.includes(resultUrl, "?");
                if (!hasOtherParams) {
                    // No other params in the url, remove & and prepend with a ?
                    additionalParams = "?" + additionalParams.slice(1);
                }
            }
        }

        resultUrl = resultUrl.replace("ADDITIONAL_PARAMS", additionalParams);
    }

    debug.log("### store link url", resultUrl);
    return resultUrl;
}

export function getProductUrl(product?: IStoreProduct) {
    if (!product) {
        return;
    }

    let url = product.url;
    if (!url) {
        return;
    }

    return replaceAdditionalParams(url, product.offer, product.appendOfferInformation);
}



// WEBPACK FOOTER //
// ./src/components/store/StoreStore.ts